<div style="text-align:center;padding-top:15%;">

<h2><b>OFFICE ADDRESS</b></h2>

    <p style="margin-left: 10px;">03rd & 04th Floor, FDA Bhawan,<br> Kotla Road Near Bal Bhawan, New Delhi - 110002 India.
    <!-- <p style="margin-left: 10px;">Email ID: <a href="mailto:labs@fssai.gov.in">labs@fssai.gov.in</a></p> -->
    <p style="margin-left: 10px;">Email ID: <a href="mailto:fsw.mftl@fssai.gov.in">fsw.mftl@fssai.gov.in</a></p>
</div>